const expandButton = document.getElementById("lux-checkout-preview-expand");

if (expandButton) {
    const luxCheckoutStickyWrapper = document.querySelector(
        ".lux-checkout-sticky-wrapper",
    );
    const luxCheckoutExtra = document.getElementById(
        "lux-checkout-preview-extra",
    );
    const luxCheckoutPreviewFullHeight = luxCheckoutStickyWrapper.offsetHeight;

    const reorderUpdateProducts = document.querySelectorAll(
        ".lux-cart-product .reorder-update-products",
    );

    const reorderChooseDelivery = document.getElementById(
        "reorder-choose-delivery",
    );

    const reorderDeliveryReminder = document.getElementById(
        "lux-cart-preview-reorder-reminder",
    );

    luxCheckoutStickyWrapper.classList.remove("expand", "expand-temp");

    const luxCheckoutExtraMargin = () => {
        if (luxCheckoutExtra) {
            luxCheckoutStickyWrapper.style.marginBottom = `${luxCheckoutExtra.offsetHeight}px`;
        }
    };

    const checkStickyState = () => {
        const rect = luxCheckoutStickyWrapper.getBoundingClientRect();
        const fullBottom = rect.top + luxCheckoutPreviewFullHeight;

        const isSticky = Math.round(fullBottom) >= window.innerHeight;
        const isStickyBottom = Math.round(rect.bottom) === window.innerHeight;

        if (!isSticky) {
            luxCheckoutStickyWrapper.classList.add("initial-position");
        }

        if (isStickyBottom) {
            luxCheckoutStickyWrapper.classList.remove("initial-position");
        }
    };

    const checkReorderDelivery = () => {
        if (reorderChooseDelivery) {
            reorderDeliveryReminder.classList.toggle(
                "show",
                !reorderChooseDelivery.classList.contains("hide"),
            );
        }
    };

    const handleReorderUpdateClick = () => {
        setTimeout(() => {
            luxCheckoutExtraMargin();
            checkReorderDelivery();
        }, 200);
    };

    reorderUpdateProducts.forEach((button) =>
        button.addEventListener("click", handleReorderUpdateClick),
    );

    expandButton.addEventListener("click", () => {
        luxCheckoutStickyWrapper.classList.toggle("expand");
    });

    window.addEventListener("scroll", checkStickyState, { passive: true });
    window.addEventListener("resize", checkStickyState);

    luxCheckoutExtraMargin();
    checkReorderDelivery();
    checkStickyState();
}
